import React from 'react';
import CusButton from '@/components/CusButton';
import { useShowMore } from '@/utils/hooks';
import { trackClickEvent } from '@/utils/site-track';

const DataInterpretationSEO = (props: {
  children: React.ReactNode;
  className?: string;
  lineClamp?: string;
  dataEleGroup?: string;
  dataEleId?: string;
}) => {
  const {
    children,
    className = 'text-opacity-65',
    lineClamp = 'line-clamp-3',
    dataEleGroup,
    dataEleId = 'expand',
  } = props;
  const [showMore, setShowMore] = React.useState(false);
  const [showButton, setShowButton] = React.useState(true);
  const textRef = React.useRef<HTMLParagraphElement>(null);

  useShowMore(textRef, (val) => setShowButton(val));

  return (
    <>
      <p
        data-more={showMore}
        className={`mt-4 text-base text-black font-medium ${className} data-[more=true]:line-clamp-none ${lineClamp} tablet:text-xs tablet:leading-5`}
        ref={textRef}
      >
        {children}
      </p>
      {lineClamp !== 'line-clamp-none' && (
        <CusButton
          data-show={showButton}
          className="underline text-blue-600 text-base font-medium data-[show=false]:invisible tablet:text-xs"
          onClick={(e) => {
            setShowMore(!showMore);
            dataEleGroup && !showMore && trackClickEvent(e);
          }}
          data-ele-group={dataEleGroup ? `${dataEleGroup}_expand` : undefined}
          data-ele-id={dataEleId}
        >
          {showMore ? '收起' : '展开'}
        </CusButton>
      )}
    </>
  );
};

export default DataInterpretationSEO;
